var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"info-badge"},[_c('div',{staticClass:"info-badge__info",class:{
      'info-badge__info--grey': _vm.grey,
      'info-badge__info--red': _vm.red,
      'info-badge__info--green': _vm.green,
    },on:{"mouseover":_vm.showDetails,"mouseleave":_vm.hideDetails}},[_vm._t("info")],2),_vm._v(" "),(_vm.hasSlot('title'))?_c('div',{staticClass:"info-badge__title"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),(_vm.hasSlot('details'))?_c('div',{staticClass:"info-badge__details",class:{ 'info-badge__details--active': _vm.isHoverDetails }},[_vm._t("details")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }